/**
 * Modal window directive for Edit functionality
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmPlaylistAssetRow', [function () {
    return {
      restrict: 'E',
      scope: {
        asset: '=?',
        isHeader: '=?'
      },
      replace: true,
      controller: 'PlaylistAssetRowController',
      templateUrl: 'lm-table-rows/playlist-asset-row/playlist-asset-row.tpl.html'
    };
  }]);
lmApp
  .controller('PlaylistAssetRowController', ['$scope', '$rootScope', '$templateCache', '$compile', 'AssetService', 'MetadataService',
    function ($scope, $rootScope, $templateCache, $compile, AssetService, MetadataService) {
      if ($scope.isHeader) return;

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      $scope.status = {};

      $scope.assetWatcher = $scope.$watchCollection('asset', function(newValue, oldValue) {

        if (newValue.resources) {
          AssetService.GetPoster(newValue)
            .then(function (url) {
              $scope.posterData = {
                url: url,
                t: _.get(_.find(newValue.resources, {type: 'picture'}), 'uptime_time') || Date.now()
              }
            });

          $scope.status._deployed = {
            stream: newValue.resources.filter(function (resource) {

              return resource.type === 'stream';
            })
          };
        }

      });

      $scope.$on('$destroy', function () {
        $scope.assetWatcher();
      });
    }]);
